
import { useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

export default function GoogleAnalytics({ id, basename = "", debug = false, trackPathnameOnly = false, children }) {
  const location = useLocation();

  useEffect(() => {
    if (!id) {
      console.error("[GA] Tracking ID is required.");
      return;
    }

    ReactGA.initialize(id, { debug });

    // Initial pageview
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
      title: document.title,
    });
  }, [id, debug]);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
      title: document.title,
    });
  }, [location]);

  return children || null;
}

GoogleAnalytics.propTypes = {
  id: PropTypes.string.isRequired,
  basename: PropTypes.string,
  debug: PropTypes.bool,
  trackPathnameOnly: PropTypes.bool,
  children: PropTypes.node,
};
